import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { filterEmpty } from './utils'
// ///////////////////////////////////////////////////////
const defaultElevation = {
  'item': 2,
  'card': 2,
  'actionbar': 4,
  'fab': 6,
  'snackbar': 6,
  'tabbar': 8,
  'drawer': 16,
  'dialog': 24
}
// ///////////////////////////////////////////////////////
export const composeElevationStyle = props => {
  const e = valueForKeyPath('theme.elevation', props) || defaultElevation
  const elevation = props.z ? e[props.z] : null
  return filterEmpty({ elevation })
}
